// extracted by mini-css-extract-plugin
export default {"eventCalendar":"CmsEventCalendar-module__eventCalendar-PnY8Ph"};